export const CONFIG_PARAM_OPTION_REQUEST_TARGET = '/api/config_param_options'
